import "./Announcements.scss"
const Announcements = () => {
  return (
    <div className="announcements">
      <div className="announcements-navbar">
        <span className="announcements-title">Announcements</span>
        <span className="announcements-view-all">View All</span>
      </div>
      <div className="announcements-content">
        <div className="announcements-card">

          <div className="announcements-card-navbar">
            <span className="announcements-card-title">Scheduled System Maintenance</span>
            <span className="announcements-card-time">10 minutes ago</span>
          </div>
          <div className="announcements-card-desc">
            ⏳ Our system will undergo routine maintenance on March 15, 2025, from 12:00 AM to 4:00 AM. Some services may be temporarily unavailable during this period. We apologize for any inconvenience and appreciate your patience.    </div>
          <div className="announcements-card-footer">
            <span className="more">More...</span>
          </div>
        </div>

        <div className="announcements-card">
          <div className="announcements-card-navbar">
            <span className="announcements-card-title">New Feature: Digital Prescription Tracking</span>
            <span className="announcements-card-time">37 minutes ago</span>
          </div>
          <div className="announcements-card-desc">
            📜 You can now track your prescriptions digitally! Our latest update allows you to view, renew, and receive notifications for your medications. Log in to your account to explore this new feature.       </div>
          <div className="announcements-card-footer">
            <span className="more">More...</span>
          </div>
        </div>


        <div className="announcements-card">
          <div className="announcements-card-navbar">
            <span className="announcements-card-title">Faster Appointment Scheduling Now Available</span>
            <span className="announcements-card-time">6 hours ago</span>
          </div>
          <div className="announcements-card-desc">
            📅 We have improved our appointment booking system for quicker scheduling and fewer delays. Log in today to book your next consultation seamlessly!          </div>
          <div className="announcements-card-footer">
            <span className="more">More...</span>
          </div>
        </div>


        <div className="announcements-card">
          <div className="announcements-card-navbar">
            <span className="announcements-card-title">5. Security Alert: Protect Your Account</span>
            <span className="announcements-card-time">7 hours ago</span>
          </div>
          <div className="announcements-card-desc">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel nam quidem tempora, quibusdam qui quos dolorem doloremque quas, soluta suscipit delectus magni possimus sed quam optio reprehenderit nostrum id consectetur.
          </div>
          <div className="announcements-card-footer">
            <span className="more">More...</span>
          </div>
        </div>

        <div className="announcements-card">
          <div className="announcements-card-navbar">
            <span className="announcements-card-title">Important: Annual Insurance Coverage Update</span>
            <span className="announcements-card-time">2 days ago</span>
          </div>
          <div className="announcements-card-desc">
            🛡️ If you are enrolled in a state-funded health program, please review your insurance coverage details for 2025. Ensure your information is up to date to avoid disruptions in service.   </div>
          <div className="announcements-card-footer">
            <span className="more">More...</span>
          </div>
        </div>

        <div className="announcements-card">
          <div className="announcements-card-navbar">
            <span className="announcements-card-title">Security Alert: Protect Your Account</span>
            <span className="announcements-card-time">2 days ago</span>
          </div>
          <div className="announcements-card-desc">
            🔒 Your security is our priority. Please enable two-factor authentication (2FA) for enhanced protection. Go to your account settings to activate it now.          </div>
          <div className="announcements-card-footer">
            <span className="more">More...</span>
          </div>
        </div>

        <div className="announcements-card">
          <div className="announcements-card-navbar">
            <span className="announcements-card-title">Emergency Hotline Now Available 24/7</span>
            <span className="announcements-card-time">2 days ago</span>
          </div>
          <div className="announcements-card-desc">
            📞 Need urgent medical assistance? Our emergency support hotline is now available 24/7 for faster response times. Access the hotline via the app or call our dedicated number anytime.          </div>
          <div className="announcements-card-footer">
            <span className="more">More...</span>
          </div>
        </div>


        <div className="announcements-card">
          <div className="announcements-card-navbar">
            <span className="announcements-card-title">Patient Portal Now Supports Family Accounts</span>
            <span className="announcements-card-time">3 days ago</span>
          </div>
          <div className="announcements-card-desc">
            👨‍👩‍👧‍👦 Managing healthcare for your loved ones just got easier! You can now link family members to your account and access their medical records, appointments, and prescriptions from a single dashboard.
          </div>
          <div className="announcements-card-footer">
            <span className="more">More...</span>
          </div>
        </div>

        <div className="announcements-card">
          <div className="announcements-card-navbar">
            <span className="announcements-card-title">Health Tips & Wellness Program Launched</span>
            <span className="announcements-card-time">3 days ago</span>
          </div>
          <div className="announcements-card-desc">
            💡 Stay informed and take charge of your health! Our new Wellness Program offers personalized health tips, exercise routines, and dietary recommendations based on your medical history. Sign up today!                    </div>
          <div className="announcements-card-footer">
            <span className="more">More...</span>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Announcements